import {
  ptacUnitActiveItem,
  isPtacAmperageLabel,
  isPtacVoltageLabel
} from '@alpinehomeair/common';
import {
  ConfigurationType,
  PtacSystemUnitInputType,
  ValidPtacSystemsRequestType
} from 'data/types';
import { ptacUnitLoad, ptacUnitName } from 'utils/ptac-configuration';
import { resolvePtacElectricalFilter } from 'utils/ptac-electrical-filter';
import { PtacSystemsRequestParams } from 'utils/ptac-systems-request-types';

export const PTAC_SYSTEMS_URL = 'valid-ptac-systems';

export function ptacSystemsUnitsPayload(
  configuration: ConfigurationType
): PtacSystemUnitInputType[] {
  return configuration.condensers.flatMap((unit) => {
    const zone = unit.zones[0];
    if (!zone || zone.zoneItems.length === 0) return [];
    const load = ptacUnitLoad(unit);
    const activeItem = ptacUnitActiveItem(unit);
    return [
      {
        condenserUniqueId: unit.uniqueId,
        name: activeItem ? ptacUnitName({ label: activeItem.name }) : unit.name,
        roomLabel: activeItem?.name ?? unit.name,
        ...(unit.heightOffGround !== undefined
          ? { heightOffGround: unit.heightOffGround }
          : {}),
        zone: {
          uniqueId: zone.uniqueId,
          name: zone.name,
          zoneItems: zone.zoneItems
        },
        coolingBtu: Math.round(load.cooling),
        heatingBtu: Math.round(load.heating)
      }
    ];
  });
}

export function buildPtacSystemsRequestBody(
  params: PtacSystemsRequestParams
): ValidPtacSystemsRequestType {
  const { filters, electricalDefaults } = params;
  const voltage = resolvePtacElectricalFilter(
    filters.voltage,
    electricalDefaults.voltage
  );
  const amperage = resolvePtacElectricalFilter(
    filters.amperage,
    electricalDefaults.amperage
  );
  return {
    systemUniqueId: params.anchorSystemUniqueId,
    configurationUniqueId: params.configuration.uniqueId,
    configurationName: params.configuration.name,
    units: ptacSystemsUnitsPayload(params.configuration),
    inStockOnly: params.inStockOnly,
    ...(params.priceMin !== null ? { priceMin: params.priceMin } : {}),
    ...(params.priceMax !== null ? { priceMax: params.priceMax } : {}),
    ...(filters.terminalType ? { terminalType: filters.terminalType } : {}),
    ...(filters.manufacturers?.length
      ? { manufacturers: filters.manufacturers }
      : {}),
    ...(filters.series?.length ? { series: filters.series } : {}),
    ...(voltage !== null && isPtacVoltageLabel(voltage) ? { voltage } : {}),
    ...(amperage !== null && isPtacAmperageLabel(amperage) ? { amperage } : {}),
    ...(params.zipCode ? { zipCode: params.zipCode } : {}),
    ...(params.customSelections.length > 0
      ? { customSelections: params.customSelections }
      : {})
  };
}
